export class CategoryDtoModel {

    label?: string;
    oldLabel?: string;
    backgroundImagePath?: string;
    emoji?: string;
    uuid?: string;
    priority?: number;
    family?: boolean;
    defaultKeyValue?: string;
}
